// import React from 'react';
import React, { useEffect } from 'react';


import { FormFieldDefinitions, surfacingProductHandleToType } from './formDefinitions';
import { surfacingConfig, turfConfig } from './constants';



import isEmail from 'validator/lib/isEmail';
// import isMobilePhone from 'validator/lib/isMobilePhone';
// import isPostalCode from 'validator/lib/isPostalCode';

export function findItemByProductId(items, numericId) {
  const want = String(numericId);
  return (items ?? []).find((item) => {
    const raw = item.productId ?? item.product_id ?? item.product?.id ?? '';
    return normalizeProductId(raw) === want;
  });
}
export function normalizeProductId(id) {
  if (!id) return '';
  return String(id).replace(/^gid:\/\/shopify\/Product\//i, '');
}


export const gid = (variantId) => `gid://shopify/ProductVariant/${variantId}`;

export function pickVariant(table, targetPrice) {
  return (
    table.find((v) => v.price >= targetPrice) ??
    table[table.length - 1]
  );
}


export const validateFields = (formData, taxFile) => {
  const validateField = (field) => {
    const fieldValue = formData[field.name];
    let error = "";
    if (field.required && !fieldValue) {
      error = "This field is required.";
    } else if (field.type === 'email' && (!isEmail(fieldValue) || fieldValue.includes('.comm') || fieldValue.includes('.ogr') || fieldValue.includes('.vom'))) {
      error = 'Please enter a valid email';
    } else if (field.type === 'tel' && fieldValue) {
      // Extract only digits from the phone number
      const digitsOnly = fieldValue.replace(/\D/g, '');
      if (digitsOnly.length !== 10) {
        error = 'Please enter a valid 10-digit phone number';
      }
    } else if (field.name === 'zip_code') {
      const zipCode = fieldValue || '';
      // Remove non-digit characters to check length
      const digitsOnly = zipCode.replace(/\D/g, '');
      if (digitsOnly.length < 5) {
        error = 'Zip code must be at least 5 digits';
      }
      // else if (!isPostalCode(formData[field.name], 'US')) {
      //   error = 'Please enter a valid zip code';
      // }
    } else if (field.name === 'tax_certificate' && formData['tax_exempt'] === "Yes" && !taxFile.base64) {
      error = "If your organization is tax exempt, you must submit a tax exemption certificate.";
    } else if (field.name === 'terms_of_service' && !formData['terms_of_service']) {
      error = "You must agree to the terms of service.";
    }
    return error;
  };

  return { validateField };
};







/**
 * Filters product tags, excluding specified tags and tags with specific prefixes
 * @param {string[]} tags - Array of product tags
 * @param {Object} options - Filtering options
 * @param {string[]} options.excludeTags - Array of exact tags to exclude (default: ['Update'])
 * @param {string[]} options.excludePrefixes - Array of prefixes to exclude (e.g., ['__label:', 'prefix-'])
 * @returns {string[]} Filtered array of tags
 */
export const filterProductTags = (tags, options = {}) => {
  if (!Array.isArray(tags)) {
    return [];
  }
  const { excludeTags = ['Update'], excludePrefixes = [] } = options;
  return tags.filter(tag => {
    // Exclude exact tag matches
    if (excludeTags.includes(tag)) {
      return false;
    }
    // Exclude tags that start with any of the specified prefixes
    if (excludePrefixes.some(prefix => tag.startsWith(prefix))) {
      return false;
    }
    return true;
  });
};



export const textById = (id) => document.getElementById(id)?.textContent ?? undefined;

export const calculateExpirationDate = (date = new Date()) => {
    return date.getDate() >= 15 
    ? new Date(date.getFullYear(), date.getMonth() + 2, 0) 
    : new Date(date.getFullYear(), date.getMonth() + 1, 15);
}



/**
 * Normalize "Yes/No" (and similar) form values to boolean.
 * Accepts: 'Yes'/'No', 'WillyGoat', true/false, 'true'/'false', 1/0, etc.
 */
export const isYes = (value) => {
  if (value === true) return true;
  if (value === false) return false;
  if (value == null) return false;

  const s = String(value).trim().toLowerCase();
  return s === 'yes' || s === 'true' || s === '1' || s === 'willygoat';
};

export function formDataFromStorage() { 
  let storageFormData = initialFormData();
  const storedData = localStorage.getItem("quoteFormData");

  if (storedData) {
    try {
      const parsedData = JSON.parse(storedData);
      if (typeof parsedData === 'object' && parsedData !== null) {
        storageFormData = parsedData;
      }
    } catch (e) {
      console.error("Failed to parse stored form data", e);
    }
  }

  return storageFormData;
}

export function initialFormData() {
  let initData = {}
  FormFieldDefinitions.forEach( field => {
    initData[field.name] = ""
  });
  return initData;
}

export function getQuoteItemProductHandle(item) {
  if (item?.handle) return item.handle;
  if (!item?.url) return null;
  const m = String(item.url).match(/\/products\/([^/?#]+)/);
  return m ? m[1] : null;
}

/** First quote line whose handle maps in surfacingProductHandleToType → that surface type, else null */
export function getSurfacingTypeFromQuoteItems(items) {
  if (!Array.isArray(items)) return null;
  for (const item of items) {
    const h = getQuoteItemProductHandle(item);
    if (h && surfacingProductHandleToType[h]) {
      return surfacingProductHandleToType[h];
    }
  }
  return null;
}


const getLocalStorageItem = (key, type = 'string') => {
  const data = localStorage.getItem(key);
  if (typeof data === 'undefined') return null;
  if (type === 'object') {
    try {
      return JSON.parse(data);
    } catch (e) {
      return data;
    }
  } else {
    return data;
  }
};

  
export const WebhookPayload = ({
  items = [],
  formData = {},
  taxFile = null,
  expirationDate = null,
  converted_total = null,
  quoteId = null,
  analyticsData = {},
  totalInstallationCost = undefined,
  totalInstallationPrice = undefined,
} = {}) => {
  const itemsResolved = items ?? [];
  const formDataResolved = formData ?? {};
  const taxFileResolved = taxFile;
  const expirationDateResolved = expirationDate;
  const convertedTotalResolved = converted_total;
  const totalInstallationCostResolved = totalInstallationCost;
  const totalInstallationPriceResolved = totalInstallationPrice;
  const quoteIdResolved = quoteId;

  const installationBoolean = ['willygoat', 'yes'].includes(
    String(formDataResolved['quote_installation'] ?? '').toLowerCase()
  ) ? 'Yes' : "No";

  const hasSurfacing = formDataResolved['surfacing_request'] == 'Yes';
  const hasPIPProduct = itemsResolved.some(item => item.productId == surfacingConfig.surfacing_product_id);
  const hasPip = hasPIPProduct || (hasSurfacing && formDataResolved['surfacing_type'] == 'Pour in Place Surfacing') ? 'Yes' : 'No';
  const hasTurfProduct = itemsResolved.some(item => item.productId == turfConfig.turf_product_id);
  const hasTurf = hasTurfProduct || (hasSurfacing && formDataResolved['surfacing_type'] == 'Artificial Turf') ? 'Yes' : 'No';
  const hasEWF = hasSurfacing && formDataResolved['surfacing_type'] == 'Engineered Wood Fiber' ? 'Yes' : 'No';
  const hasRubberMulch = hasSurfacing && formDataResolved['surfacing_type'] == 'Rubber Mulch' ? 'Yes' : 'No';

  const elevarParamsObj = (typeof analyticsData === 'object' && analyticsData) ? analyticsData : {};

  const gclid_data =
    analyticsData?.gclid_value ||
    analyticsData?.gclid ||
    analyticsData?.google_ads_click_id ||
    null;

  const used_pip_calculator =
    analyticsData?.used_pip_calculator ?? null;

    // const converted_total = totalPrice / 100;
      // let quote_value_adj = Math.min(converted_total * 0.2, 50000); // Simplified adjustment calculation

    // let tiered_pct;
    // if (converted_total <= 5000) {
    //   tiered_pct = 0.20;
    // } else if (converted_total <= 10000) {
    //   tiered_pct = 0.20 + ((converted_total - 5000) / 5000) * 0.05;
    // } else if (converted_total <= 25000) {
    //   tiered_pct = 0.25;
    // } else if (converted_total <= 40000) {
    //   tiered_pct = 0.25 - ((converted_total - 25000) / 15000) * 0.05;
    // } else if (converted_total <= 60000) {
    //   tiered_pct = 0.20 - ((converted_total - 40000) / 20000) * 0.05;
    // } else if (converted_total <= 80000) {
    //   tiered_pct = 0.15 - ((converted_total - 60000) / 20000) * 0.02;
    // } else {
    //   tiered_pct = 0.13;
    // }
    // const tierred_value = Math.min(converted_total * tiered_pct, 25000);

    // console.log('tierred_value', tierred_value);
    // const interestCategories = getLocalStorageItem("wgCollectionNames", 'object').map(item => `"${item.trim()}"`).join(', ');
    // const filteredFormData = filterFieldsForWebhook(formData);

    // const filteredFormData = Object.keys(formData).reduce((acc, key) => {
    //   if (formData[key].type !== 'header') {
    //       acc[key] = formData[key];
    //   }
    //   return acc;
    // }, {});

    /*
    let payloadData = {
      additional_data: formData,
      items: items,
      quote_installation: installationBoolean,
      tax_exemption_data: taxFile?.base64,
      interest_categories: localStorageCustomData?.interest_categories || getLocalStorageItem("wgCollectionNames") || undefined,
      client_id: localStorageCustomData?.client_id || getGAClientId(),
      quoteId: localStorageCustomData?.quote_id || getLocalStorageItem("quoteId"),
      elevar_params: localStorageCustomData?.elevar_params,
      elevar_cookies: localStorageCustomData?.elevar_cookies,
      expirationDate: expirationDate,
      convertedTotal: converted_total || undefined,
      gclid_value: gclid_data,
      gclid: gclid_data,
      google_ads_click_id: gclid_data,
      magazine_visitor: localStorageCustomData?.magazine_visitor || getLocalStorageItem("wg_church_10_24_visitor") || undefined,
      ...localStorageCustomData,
  };
  */
  
  // console.log('localStorageCustomData - 2', localStorageCustomData);

  

  
  let payloadData = {
    // installation_cost: totalInstallationCost || undefined,
    // installation_price: totalInstallationPrice || undefined,
    // additional_data: formData,
    additional_data: {
      ...formDataResolved,
      quote_installation: installationBoolean,
      pip_request: hasPip,
      turf_request: hasTurf,
      ewf_request: hasEWF,
      rubber_mulch_request: hasRubberMulch,
      used_pip_calculator: used_pip_calculator,
    },
    items: itemsResolved,
    tax_exemption_data: taxFileResolved?.base64,
    client_id: analyticsData?.client_id ?? null,
    quoteId: quoteIdResolved,
    elevar_params: analyticsData?.elevar_params ?? null,
    elevar_cookies: analyticsData?.elevar_cookies ?? null,
    expirationDate: expirationDateResolved,
    convertedTotal: convertedTotalResolved || undefined,
    gclid_value: gclid_data,
    gclid: gclid_data,
    ...(analyticsData || {}),
    google_ads_click_id: gclid_data,
    submissionDate: new Date().toISOString(),
  };

  if (totalInstallationCostResolved !== undefined) {
    payloadData.inst_c = totalInstallationCostResolved;
  }

  if (totalInstallationPriceResolved !== undefined) {
    payloadData.inst_p = totalInstallationPriceResolved;
  }

  if (totalInstallationPriceResolved !== undefined && installationBoolean === 'Yes') {
    // payloadData.inst_conv_p = totalInstallationPriceResolved * 0.2;
    payloadData.inst_conv_p = totalInstallationPriceResolved * 0.05;
  }

  
  return payloadData;
};


export const enhancedConversionItems = (items) => {
    return items.map(function(product) {
      return {
        'id': "shopify_US_" + product.productId + "_" + product.variantId,
        'price': product.price / 100,
        'quantity': product.quantity,
        'name': product.title,
        'google_business_vertical': 'retail'
      }
    });
}
export const klavityoItems = (items) => {
  return items.map(function(product) {
    return {
      "ProductName": product.title,
      "ProductID": product.productId,
      "SKU": product.sku,
      "VaritantID": product.variantId,
      "ItemPrice": product.price / 100,
      "Quantity": product.quantity,
      "RowTotal": (product.price / 100) * product.quantity,
      "Brand": product.brand,
      "ProductURL": location.href.split( '/' )[0] + '//' + location.href.split( '/' )[2] + product.url,
      "ImageURL": product.featuredImage,
      "Categories": product.collections
    }
  });
}

export const getBase64 = file => {
    return new Promise(resolve => {
      let baseURL = "";
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
};



// Custom hook for outside click detection
export const useOutsideAlerter = (ref, isOpen, onClose, quoteLinkRef = null, manageMobileScroll = false) => {
  useEffect(() => {
    if (isOpen) {
      const close = (e) => {
        const isEscape = e.key === 'Escape';
        const isOutsideRef = !e.key && ref.current && !ref.current.contains(e.target);
        const isOutsideQuoteLink = !quoteLinkRef || !quoteLinkRef.current || !quoteLinkRef.current.contains(e.target);
        
        if (isEscape || (isOutsideRef && isOutsideQuoteLink)) {
          if (manageMobileScroll) {
            document.body.classList.remove('no-mobile-scroll');
          }
          // Support both callback signatures (with or without event)
          if (onClose.length > 0) {
            onClose(e);
          } else {
            onClose();
          }
        }
      };
      window.addEventListener('keydown', close);
      document.addEventListener('mousedown', close);
      return () => {
        window.removeEventListener('keydown', close);
        document.removeEventListener('mousedown', close);
      };
    } else if (manageMobileScroll) {
      document.body.classList.add('no-mobile-scroll');
    }
  }, [ref, isOpen, onClose, quoteLinkRef, manageMobileScroll]);
};

// Alias for quote-specific usage with mobile scroll management
export const useOutsideAlerterQuote = (ref, isOpen, toggleMiniQuote, quoteLinkRef) => {
  return useOutsideAlerter(ref, isOpen, toggleMiniQuote, quoteLinkRef, true);
};